// Enhanced image preloader
// This script runs before React mounts and ensures critical images are loaded
// and supports persistence of images across navigation

// List of critical images to preload
const CRITICAL_IMAGES = [
  '/home/dejv/ridley/src/images/ridley.png',
  '/home/dejv/ridley/src/images/ridley-dealers.png',
  '/home/dejv/ridley/src/images/logo-white.png',
  '/home/dejv/ridley/src/images/bike.png'
];

// Get the image cache from sessionStorage or create a new one
export const getImageCache = () => {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    const cache = sessionStorage.getItem('ridleyImageCache') || '{}';
    return JSON.parse(cache);
  }
  return {};
};

// Main image cache object
const imageCache = getImageCache();

// Save the cache state to sessionStorage
export const updateImageCache = (src) => {
  if (!src) return;
  
  imageCache[src] = true;
  if (typeof window !== 'undefined' && window.sessionStorage) {
    sessionStorage.setItem('ridleyImageCache', JSON.stringify(imageCache));
  }
};

// Function to preload an image and return a promise
export const preloadImage = (src, onSuccess, onError) => {
  return new Promise((resolve) => {
    // If already in cache, just resolve
    if (imageCache[src]) {
      if (typeof onSuccess === 'function') {
        onSuccess();
      }
      resolve({ src, success: true });
      return;
    }

    const img = new Image();
    img.onload = () => {
      updateImageCache(src);
      if (typeof onSuccess === 'function') {
        onSuccess();
      }
      resolve({ src, success: true });
    };
    
    img.onerror = () => {
      if (typeof onError === 'function') {
        onError();
      }
      resolve({ src, success: false });
    };
    
    img.src = src;
  });
};

// Prevent cache busting that might interfere with CSS styling
export const getCacheBusterUrl = (url) => {
  // Just return the original URL to maintain hover effects and styling
  return url;
};

// Initialize preloading for critical images
if (typeof window !== 'undefined') {
  // Attach to window for debugging
  window.ridleyPreloader = {
    images: {},
    preloadedCount: 0
  };
  
  // Start preloading before React mounts
  Promise.all(CRITICAL_IMAGES.map(preloadImage))
    .then(results => {
      results.forEach(result => {
        window.ridleyPreloader.images[result.src] = result.success;
        if (result.success) {
          window.ridleyPreloader.preloadedCount++;
        }
      });
      console.log(`Preloaded ${window.ridleyPreloader.preloadedCount}/${CRITICAL_IMAGES.length} critical images`);
    });
  
  // Add a listener to handle navigation back to home
  window.addEventListener('popstate', function(event) {
    // Check if we're on the home page
    if (window.location.pathname === '/' || window.location.pathname === '') {
      console.log('Navigation detected - checking image cache');
      // Flag that we're returning to the home page
      sessionStorage.setItem('returningToHome', 'true');
    }
  });
}

// Export the utilities
const imagePreloader = {
  preloadImage,
  getImageCache,
  updateImageCache,
  getCacheBusterUrl
};

export default imagePreloader;
